export function StickyNoteEmpty({ className = '' }: Readonly<{ className?: string }>) {
  return (
    <span className={`icon ${className}`} data-testid="sticky-note-icon">
      <svg
        width="200"
        height="123"
        viewBox="0 0 200 123"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M89 16C89 13.2386 86.7614 11 84 11C81.2386 11 79 13.2386 79 16V24C79 26.7614 81.2386 29 84 29C86.7614 29 89 26.7614 89 24V16Z"
          fill="var(--clr-container-bg)"
          stroke="var(--clr-border-grey-100)"
        />
        <path
          d="M39.4525 87.6194C48.2292 89.8979 56.1356 88.507 63.1715 83.4467"
          stroke="var(--clr-title)"
          strokeOpacity="0.2"
          strokeWidth="2.4"
          strokeLinecap="round"
          strokeDasharray="1 7"
        />
        <path
          d="M121 16C121 13.2386 118.761 11 116 11C113.239 11 111 13.2386 111 16V24C111 26.7614 113.239 29 116 29C118.761 29 121 26.7614 121 24V16Z"
          fill="var(--clr-container-bg)"
          stroke="var(--clr-border-grey-100)"
        />
        <path
          d="M60 35C60 27 64 23 72 23H128C136 23 140 27 140 35V101L126 117H72C64 117 60 113 60 105V35Z"
          fill="var(--clr-container-bg)"
          stroke="var(--clr-border-grey-100)"
        />
        <path d="M125.5 117L140 101H125L125.5 117Z" fill="var(--clr-border-grey-100)" />
        <path
          d="M84 57C88 61.6667 92 61.6667 96 57"
          stroke="var(--clr-general-description)"
          strokeLinecap="round"
        />
        <path
          d="M104 57C108 61.6667 112 61.6667 116 57"
          stroke="var(--clr-general-description)"
          strokeLinecap="round"
        />
        <path
          d="M92 71C97.3333 75 102.667 75 108 71"
          stroke="var(--clr-general-description)"
          strokeLinecap="round"
        />
        <path
          opacity="0.18"
          d="M78.5 69.5C80.1569 69.5 81.5 68.1569 81.5 66.5C81.5 64.8431 80.1569 63.5 78.5 63.5C76.8431 63.5 75.5 64.8431 75.5 66.5C75.5 68.1569 76.8431 69.5 78.5 69.5Z"
          fill="var(--clr-general-primary)"
        />
        <path
          opacity="0.18"
          d="M118.5 69.5C120.157 69.5 121.5 68.1569 121.5 66.5C121.5 64.8431 120.157 63.5 118.5 63.5C116.843 63.5 115.5 64.8431 115.5 66.5C115.5 68.1569 116.843 69.5 118.5 69.5Z"
          fill="var(--clr-general-primary)"
        />
        <path
          d="M72 93.5H118C117.337 93.5 116.701 93.4473 116.232 93.3536C115.763 93.2598 115.5 93.1326 115.5 93C115.5 92.8674 115.763 92.7402 116.232 92.6464C116.701 92.5527 117.337 92.5 118 92.5H72C72.663 92.5 73.2989 92.5527 73.7678 92.6464C74.2366 92.7402 74.5 92.8674 74.5 93C74.5 93.1326 74.2366 93.2598 73.7678 93.3536C73.2989 93.4473 72.663 93.5 72 93.5Z"
          fill="var(--clr-general-primary)"
        />
        <path
          opacity="0.75"
          d="M72 104.5H102C101.337 104.5 100.701 104.447 100.232 104.354C99.7634 104.26 99.5 104.133 99.5 104C99.5 103.867 99.7634 103.74 100.232 103.646C100.701 103.553 101.337 103.5 102 103.5H72C72.663 103.5 73.2989 103.553 73.7678 103.646C74.2366 103.74 74.5 103.867 74.5 104C74.5 104.133 74.2366 104.26 73.7678 104.354C73.2989 104.447 72.663 104.5 72 104.5Z"
          fill="var(--clr-general-primary)"
        />
        <path
          opacity="0.9"
          d="M33.949 88.925C26.7389 88.8035 22.9407 83.7464 25.53 78.2423C31.6028 80.009 34.5784 84.4974 33.949 88.925Z"
          fill="var(--clr-general-primary)"
        />
        <path
          opacity="0.65"
          d="M33.9483 88.925C32.1815 94.9978 26.048 96.8361 21.1125 93.4243C24.5244 88.4888 29.2667 86.9044 33.9483 88.925Z"
          fill="var(--clr-general-primary)"
        />
        <path
          opacity="0.45"
          d="M41 6L43 11L48 13L43 15L41 20L39 15L34 13L39 11L41 6Z"
          fill="var(--clr-general-primary)"
        />
        <path
          opacity="0.4"
          d="M159.6 53.2C161.036 53.2 162.2 52.0359 162.2 50.6C162.2 49.1641 161.036 48 159.6 48C158.164 48 157 49.1641 157 50.6C157 52.0359 158.164 53.2 159.6 53.2Z"
          fill="var(--clr-general-primary)"
        />
      </svg>
    </span>
  );
}
